<template>

  <select-org
    :label="label"
    type="Insurer"
    v-model="formData"
    :required="required"
    :placeholder="placeholder"
    :help-text="helpText"
    :no-form="noForm"
    value-key="value"
    :size="size"
    :disabled="disabled"
    @change="updated"
    />

</template>

<script>

import SelectOrg from '@/components/atoms/selects/SelectOrg'

export default {
  name: 'select-insurer',

  components: {
    SelectOrg
  },

  props: {
    label: {
      type: String,
      default: 'Insurer'
    },
    value: {
//      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  data () {
    return {
      formData: this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectInsurer.vue?581d60bc